export default __webpack_public_path__ + "static/media/pantry1-afterB-1440w.980deb15.avif";